/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStorageArticleSearchResult } from './APIStorageArticleSearchResult';
import {
    APIStorageArticleSearchResultFromJSON,
    APIStorageArticleSearchResultFromJSONTyped,
    APIStorageArticleSearchResultToJSON,
} from './APIStorageArticleSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIStorageArticleSearchResponse
 */
export interface APIStorageArticleSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIStorageArticleSearchResult>}
     * @memberof APIStorageArticleSearchResponse
     */
    results: Array<APIStorageArticleSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIStorageArticleSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIStorageArticleSearchResponse interface.
 */
export function instanceOfAPIStorageArticleSearchResponse(value: object): value is APIStorageArticleSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIStorageArticleSearchResponseFromJSON(json: any): APIStorageArticleSearchResponse {
    return APIStorageArticleSearchResponseFromJSONTyped(json, false);
}

export function APIStorageArticleSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStorageArticleSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIStorageArticleSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIStorageArticleSearchResponseToJSON(value?: APIStorageArticleSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIStorageArticleSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

